<template>
	<div class="container">
		<div class="sub_top">
			<div class="top_content">
				<div class="headline">
					<p class="sub_title">
						{{ $t('rtr_business-how-risk.title1') }}<br />
						{{ $t('rtr_business-how-risk.title2') }}
					</p>
					<p class="sub_text">
						{{ $t('rtr_business-how-risk.text1') }}<br />
						{{ $t('rtr_business-how-risk.text2') }}
					</p>
				</div>
			</div>
		</div>
		<section>
			<div class="sub_middle">
				<router-link :to="{ name: 'cs' }" class="link_type_02">
					<p class="text fc_white mr_10">
						{{ $t('rtr_business-how-risk.text3') }}
					</p>
					{{ $t('rtr_business-how-risk.text4')
					}}<span class="CIRCLE_ARROW"></span>
				</router-link>
			</div>
			<div class="sub_bottom">
				<h2 class="title">
					{{ $t('rtr_business-how-risk.title3') }}
				</h2>
				<p class="text">
					{{ $t('rtr_business-how-risk.text5') }}<br />
					{{ $t('rtr_business-how-risk.text6') }}
				</p>
			</div>
		</section>
		<section>
			<div class="sub_content">
				<div class="d_flex">
					<div class="detail_area">
						<div class="detail">
							<h2 class="title">
								{{ $t('rtr_business-how-risk.title4') }}
							</h2>
							<p class="text">
								{{ $t('rtr_business-how-risk.text7') }}<br />
								{{ $t('rtr_business-how-risk.text8') }}
							</p>
						</div>
					</div>
					<div class="img_area">
						<img src="@/assets/images/sub/business_risk_02.png" alt="" />
					</div>
				</div>
			</div>
		</section>
		<section>
			<div class="sub_content">
				<div class="d_flex">
					<div class="img_area">
						<img src="@/assets/images/sub/business_risk_03.png" alt="" />
					</div>
					<div class="detail_area">
						<div class="detail">
							<h2 class="title">
								{{ $t('rtr_business-how-risk.title5') }}
							</h2>
							<p class="text">
								{{ $t('rtr_business-how-risk.text9') }}<br />
								{{ $t('rtr_business-how-risk.text10') }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	name: 'Risk',
};
</script>

<style scoped></style>
